import React, { useState } from "react";
import "./FeaturesPage.css";
import { Helmet } from "react-helmet";

const FeaturesPage = () => {
  const [tab, setTab] = useState("features");

  const features = [
    "Built-in Quality",
    "24/7 Assistance",
    "Expert Guidance",
    "Multi-Channel Support",
    "Expert Solutions",
    "Remote Monitoring System",
  ];

  const benefits = [
    "High accuracy and reliability",
    "Fast turnaround time",
    "Lower operating costs",
    "Flexible for multiple applications",
    "Easy method transfer",
    "Scalable from R&D to production",
  ];

  const list = tab === "features" ? features : benefits;

  return (
    <>
      <Helmet>
        <title>Smart Automation Features | Solar Pump & ATS Technology | SEA</title>
        <meta name="description" content="Explore advanced features of SEA automation systems: Sensorless FOC, Inbuilt MPPT, Dry Run Protection, and IoT-enabled remote monitoring for solar pumps and ATS." />
        <meta name="keywords" content="SEA product features, sensorless FOC solar pump, MPPT technology, dry run protection, automatic transfer switch features, IoT remote monitoring agriculture" />
        <meta property="og:title" content="Advanced Features of Sandip electronics  & Automation Systems" />
        <meta property="og:description" content="Discover why SEA leads in energy efficiency. High-performance solar controllers and reliable automatic transfer switches with smart protections." />
        <meta property="og:image" content="https://seaiot.in/images/features-infographic.jpg" />
        <meta property="og:url" content="https://seaiot.in/featuresPage" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="page-root">
        <div className="cardfp">
          <div className="left-panel">
            <h1 className="title">Features</h1>

            <div className="toggle-group">
              <button
                className={`toggle-btn ${tab === "features" ? "active" : ""}`}
                onClick={() => setTab("features")}
              >
                Features
                <span className="toggle-dot" />
              </button>

              <button
                className={`toggle-btn outline ${tab === "benefits" ? "active-outline" : ""
                  }`}
                onClick={() => setTab("benefits")}
              >
                Benefits
                <span className="toggle-dot outline-dot" />
              </button>
            </div>
          </div>

          <div className="right-panel">
            <div className="big-circle">
              <ul className="points-list">
                {list.map((item, idx) => (
                  <li key={idx} className="point-item">
                    <span className="point-icon" />
                    <span className="point-text">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bottom-dots">
              <span className="small-dot active-dot" />
              <span className="small-dot" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeaturesPage;
